module.exports = __webpack_public_path__ + "img/sceneFour.0be567a9.png";